module.exports = __webpack_public_path__ + "img/ele-1600w.649c2f7d.jpg";